import { render, staticRenderFns } from "./PdvClosedExternal.vue?vue&type=template&id=1a2cee05"
import script from "./PdvClosedExternal.vue?vue&type=script&lang=js"
export * from "./PdvClosedExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports